import { createSlice } from "@reduxjs/toolkit";

const initialState = { open: true, prevOpen: null };

export const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    toggleDrawer(state, action) {
      state.open = !state.open;
    },
    backToPrevState(state, action) {
      if (state.prevOpen !== state.open && state.prevOpen !== null) {
        state.open = state.prevOpen;
        state.prevOpen = null;
      }
    },
    keepOpenDrawer(state, action) {
      if (state.open !== true) {
        state.open = true;
        state.prevOpen = false;
      }
    },
  },
});
export const { toggleDrawer, backToPrevState, keepOpenDrawer } =
  drawerSlice.actions;
export const drawerReducer = drawerSlice.reducer;
